import { observer } from 'mobx-react-lite'
import PageLayout from './PageLayout'
import appStore from '../storage/AppStore'
import clubStore from '../storage/ClubStore'
import { Divider } from 'primereact/divider'
import React, {useEffect} from 'react'
import {useLocation} from 'react-router-dom'

const TeamsInfo = () => {
  const location = useLocation()
  useEffect(() => {
    clubStore.getTeams()
  }, [location.pathname])
  const currency = clubStore.club.country?.currency_sign

  return (
    <PageLayout
      header={
        <div className="flex align-items-center">
          <h3 className="m-0">
            {clubStore.club.name} · {appStore.tr.teams}
          </h3>
        </div>
      }
    >
      <div className="grid">
        {clubStore.teams.map((team, index) => (
          <div key={index} className="col-12 md:col-6 lg:col-4 border-b">
            <div className="card shadow-1 h-full flex flex-column gap-2">

              {/* Header */}
              <div className="flex justify-content-between align-items-start">
                <div className="flex align-items-center gap-2">
                  {team.sport?.icon}
                  <span className="font-semibold text-lg">
                    {team.name}
                  </span>
                </div>

                {team.fee && (
                  <div className="text-right">
                    <div className="text-xs text-500">
                      {appStore.tr.fee}
                    </div>
                    <div className="font-bold text-lg">
                      {team.fee} {currency}
                    </div>
                  </div>
                )}
              </div>

              {/* Location */}
              {team.location?.name && (
                <div className="text-sm text-500 flex align-items-center gap-1">
                  <i className="pi pi-map-marker" />
                  {team.location.name}
                </div>
              )}
              
              {/* Schedule */}
              {team.schedule?.length > 0 && (
                <>
                  <div>
                    <div className="text-xs text-500 mb-1">
                      {appStore.tr.class_schedule}
                    </div>
                    <ul className="list-none p-0 m-0 flex flex-column gap-1">
                      {team.schedule.map((day, idx) => (
                        <li
                          key={idx}
                          className="text-sm flex justify-content-between"
                        >
                          <span>{appStore.tr[day.name]}</span>
                          <span className="font-medium">
                            {day.time_from} – {day.time_to}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </>
              )}

            </div>
          </div>
        ))}
      </div>
    </PageLayout>
  )
}

export default observer(TeamsInfo)
